import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const hipaaDocumentsSelector = (state: RootState) => state.hipaaDocuments;

export const hipaaDocumentsDataSelector = createSelector(hipaaDocumentsSelector, hd => hd.data);

export const hipaaDocumentsFetchingSelector = createSelector(
  hipaaDocumentsSelector,
  hd => hd.isFetching
);

export const hipaaDocumentsErrorSelector = createSelector(hipaaDocumentsSelector, hd => hd.error);
